import { apiClient } from './auth';

export interface MastersFilterOptionItem {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
  displayOrder?: number;
  campaignType?: string;
}

export interface MastersFilterOptionsData {
  leadSources: MastersFilterOptionItem[];
  sourceChannels: MastersFilterOptionItem[];
  campaigns: MastersFilterOptionItem[];
}

export interface MastersFilterOptionsResponse {
  success: boolean;
  data: MastersFilterOptionsData;
}

export interface MastersFilterOptionsParams {
  isActive?: boolean;
  search?: string;
}

export async function getMastersFilterOptionsApi(
  params: MastersFilterOptionsParams = {}
): Promise<MastersFilterOptionsResponse> {
  const queryParams = new URLSearchParams();
  if (params.isActive !== undefined) {
    queryParams.append('isActive', String(params.isActive));
  }
  if (params.search?.trim()) {
    queryParams.append('search', params.search.trim());
  }

  const query = queryParams.toString();
  const response = await apiClient.get<MastersFilterOptionsResponse>(
    query ? `/admin/masters/filter-options?${query}` : '/admin/masters/filter-options'
  );
  return response.data;
}
